import React from 'react';
import { Grid, Button, useTheme } from '@mui/material';

export const SearchButtonWrapper = ({
  id,
  onClick,
  label = 'BUSCAR',
  containerSx = {},
  buttonSx = {},
  md = 4,
}) => {
  const theme = useTheme();

  return (
    <Grid
      id={id}
      item
      xs={12}
      md={md}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: '57px',
        paddingLeft: '8px',
        mt: { xs: '14px', sm: 0 },
        pl: { xs: 0, sm: '8px' },
        ...containerSx,
      }}
    >
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          width: '100%',
          height: '56px',
          backgroundColor: theme?.primary || '#000',
          color: theme.text1,
          fontSize: '16px',
          fontWeight: 600,
          ...buttonSx,
          '&:hover': {
            bgcolor: theme?.primary || '#000',
            color: theme.text1,
            boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
            ...buttonSx,
          },
        }}
      >
        {label}
      </Button>
    </Grid>
  );
};
